<template>
  <section class="ant-layout">
    <main class="ant-layout-content">
      <div class="ant-spin-nested-loading">
        <div class="ant-spin-container">
          <div class="withdrawal-page">
            <div class="common-header">
              <font style="vertical-align: inherit"
                ><font style="vertical-align: inherit"> {{ $t('mine.Bank') }}/{{ $t('mine.USDT') }}{{ $t('mine.Managementaa') }} </font></font
              >
            </div>
            <div class="withdrawal-page-wrapper">
              <div class="withdrawal-page-wrapper-bind-card">
                <div js-tab="3" class="mt-tabpage">
                  <div class="mt-tabpage-title">
                    <a href="javascript:;" class="mt-tabpage-item"
                      ><img src="/static/image/company.png" style="margin-right: 5px" width="38" /><font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit">{{ $t('mine.Bank') }}</font></font
                      ></a
                    >
                  </div>
                  <div class="boxsss">
                    <a href="javascript:;" @click="changBindShow(1)" style="font-size: 14px" v-if="usercardLis.length < 5"
                      ><font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit">{{ $t('mine.Clickbank') }}</font></font
                      ></a
                    >

                    <div data-v-d53ef8fa="" class="bankBox">
                      <div class="lis" v-for="(item, index) in usercardLis" :key="index">
                        <div class="ps1">
                          <span style="">{{ $t('mine.BankName') }}：{{ item.bank }} </span><span class="delss" @click="delCard(item.id)">{{ $t('mine.Unbinding') }}</span>
                        </div>
                        <div class="ps1">{{ $t('mine.Banknumber') }}：{{ item.bank_no }}</div>
                        <div class="ps1">{{ $t('mine.BankHead') }}：{{ item.bank_owner }}</div>
                        <div class="ps1">{{ $t('mine.Accountaddress') }}：{{ item.bank_address }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="withdrawal-page-wrapper">
              <div class="withdrawal-page-wrapper-bind-card">
                <div js-tab="3" class="mt-tabpage">
                  <div class="mt-tabpage-title">
                    <a href="javascript:;" class="mt-tabpage-item"
                      ><img src="/static/image/zgpay.png" width="38" style="margin-right: 5px" /><font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit">{{ $t('mine.USDT') }}</font></font
                      ></a
                    >
                  </div>
                  <div class="boxsss">
                    <a href="javascript:;" @click="changBindShow(2)" style="font-size: 14px" v-if="usdssLis.length < 5"
                      ><font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit">{{ $t('mine.ClickUSDT') }}</font></font
                      ></a
                    >

                    <div data-v-d53ef8fa="" class="bankBox">
                      <div class="lis" v-for="(item, index) in usdssLis" :key="index">
                        <div class="ps1">
                          <span style="">{{ $t('mine.Wallettype') }}：{{ item.bank }} </span>
                          <span class="delss" @click="delCard(item.id)">{{ $t('mine.Unbinding') }}</span>
                        </div>
                        <div class="ps1">{{ $t('mine.Walletaddress') }}：{{ item.bank_no }}</div>
                        <div class="ps1">{{ $t('mine.Walletprotocol') }}：{{ item.bank_owner }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="width: 93%; margin: 0 auto">{{ $t('mine.Reminder') }}</div>
          </div>
        </div>
      </div>
      <div class="el-dialog__wrapper" style="background: rgba(0, 0, 0, 0.4)" v-if="bindShow == 1">
        <div role="dialog" aria-modal="true" class="el-dialog" style="margin-top: 15vh">
          <div class="el-dialog__header">
            <span class="el-dialog__title"></span><button @click="changBindShow(0)" type="button" class="el-dialog__headerbtn"><i class="el-dialog__close el-icon el-icon-close"></i></button>
          </div>
          <div class="el-dialog__body">
            <form class="el-form el-form--inline">
              <div class="el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item is-required">
                  <label for="bank" class="el-form-item__label" style="width: 220px">{{ $t('mine.selectsupporting') }}</label>
                  <div class="el-form-item__content">
                    <el-select v-model="cardInfo.bank" :placeholder="$t('mine.selectsupporting')">
                      <el-option v-for="item in banklist" :key="item.bank_name" :label="item.bank_name" :value="item.bank_name"> </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item is-required">
                  <label for="bank_address" class="el-form-item__label" style="width: 220px">{{ $t('mine.opening1') }}</label>
                  <div class="el-form-item__content">
                    <div class="el-input"><input v-model="cardInfo.bank_address" type="text" autocomplete="off" :placeholder="$t('mine.enteropening1')" class="el-input__inner" /></div>
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item is-required">
                  <label for="bank_address" class="el-form-item__label" style="width: 220px">{{ $t('mine.cardnumber1') }}</label>
                  <div class="el-form-item__content">
                    <div class="el-input"><input type="text" v-model="cardInfo.bank_no" autocomplete="off" oninput="value=value.replace(/[^0-9]/g,'')" :placeholder="$t('mine.cardnumber1')" class="el-input__inner" /></div>
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item is-required">
                  <label for="bank_address" class="el-form-item__label" style="width: 220px">{{ $t('mine.cardholder1') }}</label>
                  <div class="el-form-item__content">
                    <div class="el-input"><input type="text" v-model="cardInfo.bank_owner" autocomplete="off" :placeholder="$t('mine.cardholder1')" class="el-input__inner" /></div>
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item is-required">
                  <label for="bank_address" class="el-form-item__label" style="width: 220px">{{ $t('mine.Paymentpassword1') }}</label>
                  <div class="el-form-item__content">
                    <div class="el-input"><input type="password" v-model="cardInfo.pay_pass" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')" autocomplete="new-password" :placeholder="$t('mine.Paymentpassword1')" class="el-input__inner" /></div>
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <button type="button" class="el-button el-button--primary" @click="bindCard">
                  <span>{{ $t('mine.Binding1') }}</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="el-dialog__wrapper" style="background: rgba(0, 0, 0, 0.4)" v-if="bindShow == 2">
        <div role="dialog" aria-modal="true" class="el-dialog" style="margin-top: 15vh">
          <div class="el-dialog__header">
            <span class="el-dialog__title"></span><button @click="changBindShow(0)" type="button" class="el-dialog__headerbtn"><i class="el-dialog__close el-icon el-icon-close"></i></button>
          </div>
          <div class="el-dialog__body">
            <form class="el-form el-form--inline">
              <div class="el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item is-required">
                  <label for="bank" class="el-form-item__label" style="width: 220px">{{ $t('mine.wallet1') }}</label>
                  <div class="el-form-item__content">
                    <!-- el-select -->
                    <el-select v-model="usdtInfo.bank_owner" :placeholder="$t('mine.wallet1')">
                      <el-option label="ERC20" value="ERC20"> </el-option>
                      <el-option label="TRC20" value="TRC20"> </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item is-required">
                  <label for="bank_address" class="el-form-item__label" style="width: 220px">{{ $t('mine.USDTaddress1') }}</label>
                  <div class="el-form-item__content">
                    <div class="el-input"><input v-model="usdtInfo.bank_no" type="text" autocomplete="off" oninput="value=value.replace(/[\W]/g,'')" :placeholder="$t('mine.enterUSDTaddress1')" class="el-input__inner" /></div>
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item is-required">
                  <label for="bank_address" class="el-form-item__label" style="width: 220px">{{ $t('mine.Paymentpassword1') }}</label>
                  <div class="el-form-item__content">
                    <div class="el-input"><input type="password" v-model="usdtInfo.pay_pass" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')" autocomplete="new-password" :placeholder="$t('mine.Paymentpassword1')" class="el-input__inner" /></div>
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <button type="button" class="el-button el-button--primary" @click="bindUsdss">
                  <span>{{ $t('mine.Binding1') }}</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>
<script>
export default {
  name: 'bankSet',
  data() {
    return {
      qutype: 0,
      amount: null,
      bankId: null,
      usercardLis: [],
      usdssLis: [],
      banklist: [],
      cardInfo: {},
      usdtInfo: {},
      password: null,
      bindShow: 0,
    };
  },
  created() {
    let that = this;
    that.getUsercard();
    that.getUsdssList();
    that.getBanklist();
  },
  methods: {
    delCard(id) {
      let that = this;
      this.$prompt(that.$t('mine.Arewant'), that.$t('app.hint'), {
        confirmButtonText: that.$t('app.Yes'),
        cancelButtonText: that.$t('app.No'),
        inputPattern: /^[0-9]{6}$/,
        inputErrorMessage: that.$t('register.length'),
        inputType: 'password',
      })
        .then(({ value }) => {
          that.$parent.showLoading();

          that.$apiFun.post('/api/delcard', { id, pay_pass: value }).then(res => {
            if (res.code != 200) {
              that.$parent.showTost(0, res.message);
            }

            if (res.code == 200) {
              that.$parent.showTost(1, that.$t('mine.Unbindingsucceeded'));

              that.getUsercard();
              that.getUsdssList();
            }
            that.$parent.hideLoading();
          });
        })
        .catch(red => {
          console.log(red);
        });
      // this.$confirm(that.$t('mine.Arewant'), that.$t('app.hint'), {
      //   confirmButtonText: that.$t('app.Yes'),
      //   cancelButtonText: that.$t('app.No'),
      //   type: 'warning',
      // })
      //   .then(() => {
      //     that.$parent.showLoading();

      //     that.$apiFun.post('/api/delcard', { id }).then(res => {
      //       if (res.code != 200) {
      //         that.$parent.showTost(0, res.message);
      //       }
      //       that.$parent.hideLoading();

      //       if (res.code == 200) {
      //         that.$parent.showTost(1, that.$t('mine.Unbindingsucceeded'));

      //         that.getUsercard();
      //         that.getUsdssList();
      //       }
      //     });
      //   })
      //   .catch(() => {});
    },
    changBindShow(type) {
      let that = this;
      that.bindShow = type;
      that.cardInfo = {};
      that.usdtInfo = {};
    },
    bindUsdss() {
      let that = this;
      let usdtInfo = that.usdtInfo;
      usdtInfo.bank = 'USDT';
      if (usdtInfo.bank_no == null || usdtInfo.bank_no == '') {
        that.$parent.showTost(0, that.$t('mine.enterUSDTaddress1'));
        return;
      }
      if (!usdtInfo.bank_owner && usdtInfo.bank_owner != null) {
        that.$parent.showTost(0, that.$t('mine.wallet1'));
        return;
      }
      if (!usdtInfo.pay_pass) {
        that.$parent.showTost(0, that.$t('mine.osenterpaymentpasswordit1'));
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bindcard', usdtInfo)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, res.message);
            that.changBindShow(0);
            that.getUsercard();
            that.getUsdssList();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    bindCard() {
      let that = this;
      if (!that.cardInfo.bank_owner) {
        that.$parent.showTost(0, that.$t('mine.entername1'));
        return;
      }
      if (!that.cardInfo.bank) {
        that.$parent.showTost(0, that.$t('mine.enterthebank1'));
        return;
      }
      if (!that.cardInfo.bank_address) {
        that.$parent.showTost(0, that.$t('mine.enteraddress1'));
        return;
      }
      if (!that.cardInfo.bank_no) {
        that.$parent.showTost(0, that.$t('mine.enterbanknumber1'));
        return;
      }
      if (!that.cardInfo.pay_pass) {
        that.$parent.showTost(0, that.$t('mine.osenterpaymentpasswordit1'));
        return;
      }
      if (that.cardInfo.bank_no.length < 8) {
        that.$parent.showTost(0, that.$t('mine.correctlength1'));
        return;
      }
      if (that.cardInfo.pay_pass.length < 6 || that.cardInfo.pay_pass.length > 18) {
        that.$parent.showTost(0, that.$t('mine.enterofpassword1'));
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bindcard', that.cardInfo)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, that.$t('mine.Bindingsuccessful1'));
          }
          that.changBindShow(0);
          that.getUsercard();
          that.getUsdssList();
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getBanklist() {
      let that = this;
      that.$apiFun
        .post('/api/banklist', {})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.banklist = res.data;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changqutype(val) {
      let that = this;
      if (that.qutype == val) {
        return;
      }
      that.qutype = val;
      that.amount = null;
      that.password = null;
      that.bankId = null;
    },
    getUsercard() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 1 }).then(res => {
        if (res.code == 200) {
          that.usercardLis = res.data;
        }
      });
    },
    getUsdssList() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code == 200) {
          that.usdssLis = res.data;
        }
      });
    },
    withdraw() {
      let that = this;
      // amount	是	float	金额
      // bank	是	int	提现银行卡id
      let bank = that.bankId;
      let amount = that.amount;
      let password = that.password;

      if (amount < 100) {
        that.showTost(0, that.$t('mine.singlecannot1'));
        return;
      }
      if (!bank) {
        that.showTost(0, that.$t('mine.bankwithdrawto1'));
        return;
      }
      if (!password) {
        that.showTost(0, that.$t('mine.paymentpassword1'));
        return;
      }
      that.showLoading();
      that.$apiFun
        .post('/api/withdraw', { amount, bank, password })
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.showTost(1, that.$t('mine.successfullywaiting1'));

            that.amount = null;
            that.password = null;
            that.bank = null;
            setTimeout(() => {
              that.$router.push({ path: '/transRecord' });
            }, 1500);
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    withdraw1() {
      //  amount: "100"
      // bank: 163
      // bank_owner: "TRC20"
      // password: "1"
      let that = this;
      // amount	是	float	金额
      // bank	是	int	提现银行卡id
      let bank = that.bankId;
      let amount = that.amount;
      let password = that.password;
      if (!bank) {
        that.showTost(0, that.$t('mine.selectUSDTaddress1'));
        return;
      }
      if (amount < 100) {
        that.showTost(0, that.$t('mine.withdrawal'));
        return;
      }

      if (!password) {
        that.showTost(0, that.$t('mine.paymentpassword1'));
        return;
      }
      that.showLoading();
      that.$apiFun
        .post('/api/withdraw', { amount, bank, password })
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.showTost(1, that.$t('mine.successfullywaiting1'));
            that.chanmeyXi = null;
            that.amount = null;
            that.password = null;
            that.bank = null;
            setTimeout(() => {
              that.$router.push({ path: '/transRecord' });
            }, 1500);
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    goNav(url) {
      let that = this;
      that.$parent.goNav(url);
    },
    getUserInfo() {
      let that = this;
      that.$parent.getUserInfo();
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    openKefu() {
      this.$parent.openKefu();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/mt-style.css';
.mt-tabpage-title {
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.mt-tabpage-title .mt-tabpage-item {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.boxsss {
  width: 90%;
  margin: 20px auto;
}
.bankBox {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  .lis {
    width: calc(33% - 10px);
    border-radius: 10px;
    border: 1px solid #ccc;
    margin-right: 10px;
    box-sizing: border-box;
    padding: 5px;
    margin-top: 10px;
    .ps1 {
      word-wrap: break-word;
      white-space: pre-wrap;
      text-align: left;
      // display: flex;
      // align-items: center;
      // justify-content: space-between;
      .delss {
        color: red;
        cursor: pointer;
        float: right;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mine/bankSet.vue